import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "pickup-screen" }
const _hoisted_2 = { class: "main-content" }
const _hoisted_3 = { class: "preparing-section" }
const _hoisted_4 = { class: "section-header" }
const _hoisted_5 = { class: "section-count" }
const _hoisted_6 = { class: "order-numbers-container" }
const _hoisted_7 = { class: "order-content" }
const _hoisted_8 = {
  key: 0,
  class: "fas fa-crown vip-icon"
}
const _hoisted_9 = { class: "order-number" }
const _hoisted_10 = {
  key: 0,
  class: "empty-state"
}
const _hoisted_11 = { class: "ready-section" }
const _hoisted_12 = { class: "section-header" }
const _hoisted_13 = { class: "section-count ready-count" }
const _hoisted_14 = { class: "order-numbers-container ready-orders" }
const _hoisted_15 = { class: "order-content" }
const _hoisted_16 = {
  key: 0,
  class: "fas fa-crown vip-icon"
}
const _hoisted_17 = { class: "order-number" }
const _hoisted_18 = {
  key: 0,
  class: "empty-state"
}

import { ref, computed, onMounted, onUnmounted } from 'vue';
  import { getOrderPick } from '@/service/order';
  import { fetchShopDetail, fetchShopList } from '@/service/base';
  import { readSelectedShop } from '@/utils/selectedShop';
  import { OrderPickModel, OrderPickItemModel } from '@/model/orderPick';
  import { ShopDetailModel } from '@/model/shop';

  // 响应式数据
  
export default /*@__PURE__*/_defineComponent({
  __name: 'PickUpFoodView',
  setup(__props) {

  const shopId = ref<number | null>(null);
  const shopInfo = ref<ShopDetailModel | null>(null);
  const pickData = ref<OrderPickModel | null>(null);
  const lastRefreshTime = ref<string>('');

  // 店铺选择相关
  const shopList = ref<any[]>([]);

  // 自动刷新定时器
  let autoRefreshTimer: NodeJS.Timeout | null = null;

  // 同一取餐码可能重复，使用出现次数区分，避免列表补位触发无关号码重新入场。
  const getKeyedOrders = (orders: OrderPickItemModel[]) => {
    const occurrences = new Map<string, number>();
    return orders.map((item) => {
      const occurrence = occurrences.get(item.pickCode) ?? 0;
      occurrences.set(item.pickCode, occurrence + 1);
      return { ...item, transitionKey: `${item.pickCode}-${occurrence}` };
    });
  };

  // 离场卡片脱离网格，保留原位置，让其余卡片平滑补位。
  const freezeLeavingCard = (element: Element) => {
    if (!(element instanceof HTMLElement)) return;
    const { offsetLeft, offsetTop, offsetWidth, offsetHeight } = element;
    element.style.left = `${offsetLeft}px`;
    element.style.top = `${offsetTop}px`;
    element.style.width = `${offsetWidth}px`;
    element.style.height = `${offsetHeight}px`;
  };

  const clearLeavingCard = (element: Element) => {
    if (!(element instanceof HTMLElement)) return;
    ['left', 'top', 'width', 'height'].forEach((property) => {
      element.style.removeProperty(property);
    });
  };

  // 计算属性：准备中的订单（waitOutList：待出餐）
  const preparingOrders = computed(() => {
    return getKeyedOrders(pickData.value?.waitOutList || []);
  });

  // 计算属性：请取餐的订单（completeOutList：已出餐）
  const readyOrders = computed(() => {
    return getKeyedOrders(pickData.value?.completeOutList || []);
  });

  // 获取取餐号码（直接使用后端返回的取餐码）
  const getPickupNumber = (item: OrderPickItemModel): string => {
    if (item.pickCode) {
      return item.pickCode;
    }
    return '0000';
  };

  // 判断是否是VIP订单
  const isVipOrder = (item: OrderPickItemModel): boolean => {
    // 可以根据实际业务逻辑判断，例如：
    // 1. 取餐号包含特殊前缀（如V、VIP等）
    // 2. 取餐号有VIP标识
    // 示例：return item.pickCode?.includes('V') || item.pickCode?.startsWith('V') || false;
    return false;
  };

  // 获取餐厅信息
  const fetchShopInfo = async (id: number) => {
    try {
      const response = await fetchShopDetail({ shopId: id });
      if (response.code === 200 && response.result) {
        shopInfo.value = response.result;
      }
    } catch (error) {
      console.error('获取餐厅信息失败:', error);
    }
  };

  // 加载当前账号可见的餐厅，用于解析缓存餐厅名称。
  const loadShopList = async () => {
    try {
      const response = await fetchShopList({
        pageNum: 1,
        pageSize: 999,
        data: { shopStatus: 0 },
      });
      if (response.code === 200 && response.result && response.result.list) {
        shopList.value = response.result.list;
      }
    } catch (error) {
      console.error('加载店铺列表失败:', error);
    }
  };

  // 获取取餐号列表
  const fetchOrders = async (id: number) => {
    try {
      const response = await getOrderPick({
        shopId: id,
      });

      if (response.code === 200) {
        pickData.value = response.result || { waitOutList: [], completeOutList: [] };
        updateRefreshTime();
      } else {
        console.error('获取取餐号列表失败:', response.msg);
        pickData.value = { waitOutList: [], completeOutList: [] };
      }
    } catch (error) {
      console.error('获取取餐号列表失败:', error);
      pickData.value = { waitOutList: [], completeOutList: [] };
    }
  };

  // 更新刷新时间
  const updateRefreshTime = () => {
    const now = new Date();
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
    lastRefreshTime.value = `${hours}:${minutes}:${seconds}`;
  };

  // 启动自动刷新
  const startAutoRefresh = () => {
    // 每5秒刷新一次
    autoRefreshTimer = setInterval(() => {
      if (shopId.value) {
        fetchOrders(shopId.value);
      }
    }, 5000);
  };

  // 停止自动刷新
  const stopAutoRefresh = () => {
    if (autoRefreshTimer) {
      clearInterval(autoRefreshTimer);
      autoRefreshTimer = null;
    }
  };

  // 初始化
  onMounted(async () => {
    await loadShopList();
    const id = readSelectedShop();
    if (id) {
      shopId.value = id;
      await Promise.all([fetchShopInfo(id), fetchOrders(id)]);
      startAutoRefresh();
    }
  });

  // 清理
  onUnmounted(() => {
    stopAutoRefresh();
  });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[10] || (_cache[10] = _createElementVNode("div", { class: "top-decoration" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "bg-glow preparing-glow" }, null, -1)),
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "bg-pattern" }, null, -1)),
        _createElementVNode("div", _hoisted_4, [
          _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"title-wrapper\" data-v-c3f0df7c><div class=\"title-icon\" data-v-c3f0df7c><i class=\"fas fa-clock\" data-v-c3f0df7c></i></div><h2 class=\"section-title\" data-v-c3f0df7c><span class=\"title-main\" data-v-c3f0df7c>备餐中</span><span class=\"title-sub\" data-v-c3f0df7c>Preparing</span></h2></div>", 1)),
          _createElementVNode("div", _hoisted_5, _toDisplayString(preparingOrders.value.length), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_TransitionGroup, {
            name: "order-list",
            tag: "div",
            class: "order-list-wrapper preparing-list",
            onBeforeLeave: freezeLeavingCard,
            onAfterLeave: clearLeavingCard,
            onBeforeEnter: clearLeavingCard
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(preparingOrders.value, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: `preparing-${item.transitionKey}`,
                  class: _normalizeClass(["order-number-item", { 'vip-order': isVipOrder(item) }])
                }, [
                  _cache[1] || (_cache[1] = _createElementVNode("div", { class: "order-item-glow" }, null, -1)),
                  _createElementVNode("div", _hoisted_7, [
                    (isVipOrder(item))
                      ? (_openBlock(), _createElementBlock("i", _hoisted_8))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", _hoisted_9, _toDisplayString(getPickupNumber(item)), 1)
                  ])
                ], 2))
              }), 128))
            ]),
            _: 1
          }),
          (preparingOrders.value.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, _cache[2] || (_cache[2] = [
                _createElementVNode("i", { class: "fas fa-inbox empty-icon" }, null, -1),
                _createElementVNode("p", { class: "empty-text" }, "暂无准备中的订单", -1)
              ])))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "bg-glow ready-glow" }, null, -1)),
        _cache[9] || (_cache[9] = _createElementVNode("div", { class: "bg-pattern ready-pattern" }, null, -1)),
        _createElementVNode("div", _hoisted_12, [
          _cache[5] || (_cache[5] = _createStaticVNode("<div class=\"title-wrapper\" data-v-c3f0df7c><div class=\"title-icon ready-icon\" data-v-c3f0df7c><i class=\"fas fa-check-circle\" data-v-c3f0df7c></i></div><h2 class=\"section-title\" data-v-c3f0df7c><span class=\"title-main\" data-v-c3f0df7c>请取餐</span><span class=\"title-sub\" data-v-c3f0df7c>Ready</span></h2></div>", 1)),
          _createElementVNode("div", _hoisted_13, _toDisplayString(readyOrders.value.length), 1)
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_TransitionGroup, {
            name: "order-list",
            tag: "div",
            class: "order-list-wrapper ready-list",
            onBeforeLeave: freezeLeavingCard,
            onAfterLeave: clearLeavingCard,
            onBeforeEnter: clearLeavingCard
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(readyOrders.value, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: `ready-${item.transitionKey}`,
                  class: _normalizeClass(["order-number-item ready-item", { 'vip-order': isVipOrder(item) }])
                }, [
                  _cache[6] || (_cache[6] = _createElementVNode("div", { class: "order-item-glow ready-glow-item" }, null, -1)),
                  _createElementVNode("div", _hoisted_15, [
                    (isVipOrder(item))
                      ? (_openBlock(), _createElementBlock("i", _hoisted_16))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", _hoisted_17, _toDisplayString(getPickupNumber(item)), 1)
                  ])
                ], 2))
              }), 128))
            ]),
            _: 1
          }),
          (readyOrders.value.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, _cache[7] || (_cache[7] = [
                _createElementVNode("i", { class: "fas fa-inbox empty-icon" }, null, -1),
                _createElementVNode("p", { class: "empty-text" }, "暂无待取餐的订单", -1)
              ])))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _cache[11] || (_cache[11] = _createElementVNode("div", { class: "bottom-decoration" }, null, -1))
  ]))
}
}

})